/**
 * Start a browser file download from an in-memory Blob.
 *
 * Security: only a short-lived ``blob:`` URL is ever assigned to a detached
 * ``<a>`` — never put authenticated API URLs (e.g. CSV exports with
 * ``scope_token`` query strings) into ``href``, ``src``, or other persistent DOM.
 */

export function triggerDownloadFromBlob(blob, filename) {
  const a = document.createElement("a");
  const blobUrl = URL.createObjectURL(blob);
  try {
    a.href = blobUrl;
    a.download = filename;
    a.rel = "noopener";
    a.click();
  } finally {
    URL.revokeObjectURL(blobUrl);
  }
}
